import React, { useState } from 'react'

import ScrollButton from './ScrollButton'

import cart from '../assets/cart-2.mov'

export default function AppDetail3() {

    // const videos = [video]


    return (
        <div id="app-detail-3" className="flex flex-col">
            <div className='flex flex-col md:flex-row py-2'>
                <div className='flex flex-col md:max-w-[50%] gap-3 my-2 justify-center'>
                    <p>V receptu máte vždy podrobně uvedeny všechny ingredience a výživové hodnoty na jednu porci daného pokrmu, <strong>nemusíte nic přepočítávat</strong>.</p>
                    <p className=''>Ingredience z receptu si nemusíte zdlouhavě opisovat, jakmile máte jídelníček hotový, <strong>jedním kliknutím vytvoříte nákupní seznam</strong>. Ten si pak můžete uložit i pro příští nákupy.</p>
                    <p className='mb-2'>Přesvědčte se, <strong>jak jednoduché to je!</strong></p>
                    <ScrollButton destination="download" text="Stáhnout aplikaci" color="bg-orange-400" />
                </div>
                <div className='flex mt-5 md:mt-0 sm:max-w-[50%] mx-auto h-96'>
                    <video className="h-full w-full rounded-lg" controls controlsList="nodownload" loop>
                        <source src={cart} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>
        </div>
    )
}
